import { render, staticRenderFns } from "./CargoInput.vue?vue&type=template&id=14a18380&scoped=true&"
import script from "./CargoInput.vue?vue&type=script&lang=js&"
export * from "./CargoInput.vue?vue&type=script&lang=js&"
import style0 from "./CargoInput.vue?vue&type=style&index=0&id=14a18380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a18380",
  null
  
)

export default component.exports